<style scoped lang="scss" type="text/scss">

</style>

<template>
    <el-select class="full-width" v-model="valueSync" :disabled="disabled" :placeholder="placeholder">
        <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.full_name"
                :value="item.id">
        </el-option>
    </el-select>
</template>

<script>
    import {handlePlayers} from '../../../utils/data-handler';

    export default {
        name: '',
        props: {
            placeholder: {
                type: String,
                default: '请选择需要查看的参赛队'
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            options () {
                return handlePlayers(this.$store.state.player.currentMiddlePlayers);
            },
            currentMiddlePlayerId () {
                return this.$store.state.player.currentMiddlePlayerId;
            }
        },
        data () {
            return {
                valueSync: null
            };
        },
        watch: {
            currentMiddlePlayerId: {
                immediate: true,
                handler (current) {
                    this.valueSync = current;
                    if (current === null || current === undefined) return;
                    this.$store.dispatch('player/loadRegistrableMiddlePlayerInfo').then();
                }
            },
            valueSync (valueSync) {
                this.$store.commit('player/changeCurrentMiddlePlayerId', valueSync);
            }
        }
    };
</script>
